import React, { useEffect, useMemo, useRef, useState } from "react";
import PubgH from "../../assets/img/budahazr.png";

const API_PRODUCTS = "https://ffqadir.az/backendtest_9/api/pubg";
const API_SUBMIT = "https://ffqadir.az/backendtest_9/api/addinvoice";
const API_KART = "https://ffqadir.az/backendtest_9/api/kart";
const WHATSAPP = "https://wa.me/+994506758477";

const getPrice = (price) => {
  return (
    parseFloat(
      String(price || "").replace(",", ".")
    ) || 0
  );
};

const isMonthlyPackage = (item) => {
  const title = String(item?.title || "")
    .trim()
    .toLocaleLowerCase("az-AZ");

  return title.includes("aylıq");
};

const isSpecialPackage = (item) => {
  const title = String(item?.title || "")
    .trim()
    .toLocaleLowerCase("az-AZ");

  const price = getPrice(item?.price);

  return (
    (title.includes("3850") &&
      title.includes("uc") &&
      price === 85) ||
    (title.includes("8100") &&
      title.includes("uc") &&
      price === 165) ||
    (title.includes("16200") &&
      title.includes("uc") &&
      price === 330)
  );
};

const getProductType = (item) => {
  if (isMonthlyPackage(item)) {
    return "monthly";
  }

  if (isSpecialPackage(item)) {
    return "special";
  }

  return "normal";
};

const getUcAmount = (item) => {
  const title = String(item?.title || "");
  const matches = title.match(/\d+/g);

  if (!matches || matches.length === 0) {
    return 0;
  }

  return Math.max(
    ...matches.map((num) => parseInt(num, 10))
  );
};

export default function Pubg() {
  const [allProducts, setAllProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  const [selectedProducts, setSelectedProducts] = useState([]);

  const [modalOpen, setModalOpen] = useState(false);
  const [monthlyWarningOpen, setMonthlyWarningOpen] = useState(false);

  const [modalCount, setModalCount] = useState(1);
  const [userId, setUserId] = useState("");

  const [photoFile, setPhotoFile] = useState(null);
  const [uploadStatus, setUploadStatus] = useState("Qəbz atılmayıb");

  const [kartInfo, setKartInfo] = useState("Kart məlumatı yüklənir...");

  const [submitting, setSubmitting] = useState(false);

  /*
   * =========================================================
   * IPHONE SAFARI / VIEWPORT REFS
   * =========================================================
   */

  const savedScrollPosition = useRef(0);

  /*
   * Touch zamanı onTouchEnd + onClick birlikdə işləyərək
   * məhsulu iki dəfə seçməsin deyə istifadə olunur.
   */
  const touchHandledRef = useRef(false);
  const touchStartYRef = useRef(0);
  const touchStartXRef = useRef(0);
  const touchMovedRef = useRef(false);

  /*
   * SİFARİŞİ TƏSDİQLƏ düyməsi üçün ayrıca touch refs.
   *
   * iPhone Safari-də bottom fixed elementin ilk toxunuşunda
   * onClick gecikməsin deyə tap-i birbaşa touchend-də idarə edirik.
   */
  const orderTouchStartYRef = useRef(0);
  const orderTouchStartXRef = useRef(0);
  const orderTouchMovedRef = useRef(false);
  const orderTouchHandledRef = useRef(false);

  const [viewportHeight, setViewportHeight] = useState(null);

  /*
   * Modal açıq olub-olmadığını ref ilə izləyirik ki, Safari alt
   * toolbar-ı açılıb-bağlananda (visualViewport resize) bütün
   * komponent toxunuş ortasında yenidən render olmasın.
   */
  const anyModalOpenRef = useRef(false);

  /*
   * =========================================================
   * IPHONE SAFARI / VISUAL VIEWPORT
   * =========================================================
   */

  useEffect(() => {
    const updateViewportHeight = () => {
      if (window.visualViewport) {
        const height = window.visualViewport.height;

        document.documentElement.style.setProperty(
          "--app-viewport-height",
          `${height}px`
        );

        if (anyModalOpenRef.current) {
          setViewportHeight(height);
        }
      } else {
        const height = window.innerHeight;

        document.documentElement.style.setProperty(
          "--app-viewport-height",
          `${height}px`
        );

        if (anyModalOpenRef.current) {
          setViewportHeight(height);
        }
      }
    };

    /*
     * visualViewport scroll hadisəsində React state-i dəyişmirik.
     *
     * Safari aşağı toolbar-ı göstərib/gizlədərkən scroll event-i
     * gələ bilər. Həmin anda setState etmək fixed bottom düyməsinin
     * hit-area-sını yenidən hesablada və ilk tap-ı gecikdirə bilər.
     *
     * CSS dəyişənini birbaşa yeniləmək kifayətdir.
     */
    const updateViewportCssOnly = () => {
      if (window.visualViewport) {
        document.documentElement.style.setProperty(
          "--app-viewport-height",
          `${window.visualViewport.height}px`
        );
      }
    };

    updateViewportHeight();

    const visualViewport = window.visualViewport;

    if (visualViewport) {
      visualViewport.addEventListener(
        "resize",
        updateViewportHeight
      );

      visualViewport.addEventListener(
        "scroll",
        updateViewportCssOnly
      );
    }

    window.addEventListener(
      "resize",
      updateViewportHeight
    );

    window.addEventListener(
      "orientationchange",
      updateViewportHeight
    );

    return () => {
      if (visualViewport) {
        visualViewport.removeEventListener(
          "resize",
          updateViewportHeight
        );

        visualViewport.removeEventListener(
          "scroll",
          updateViewportCssOnly
        );
      }

      window.removeEventListener(
        "resize",
        updateViewportHeight
      );

      window.removeEventListener(
        "orientationchange",
        updateViewportHeight
      );
    };
  }, []);

  /*
   * =========================================================
   * KART MƏLUMATI
   * =========================================================
   */

  useEffect(() => {
    const getKartInfo = async () => {
      setKartInfo("Kart məlumatı yüklənir...");

      try {
        const response = await fetch(API_KART);

        if (!response.ok) {
          throw new Error(`Kart API HTTP ${response.status}`);
        }

        const data = await response.json();
        const kartTitle = data?.allKart?.[0]?.title;

        setKartInfo(
          kartTitle || "Kart məlumatı tapılmadı"
        );
      } catch (error) {
        console.error(
          "Kart məlumatı yüklənmədi:",
          error
        );

        setKartInfo("Kart məlumatı yüklənmədi");
      }
    };

    getKartInfo();
  }, []);

  /*
   * =========================================================
   * MƏHSULLARI YÜKLƏ
   * =========================================================
   */

  const getProducts = async () => {
    setLoading(true);

    try {
      const response = await fetch(API_PRODUCTS);

      if (!response.ok) {
        throw new Error(
          `Products API HTTP ${response.status}`
        );
      }

      const data = await response.json();

      if (!Array.isArray(data)) {
        setAllProducts([]);
        return;
      }

      const sortedProducts = [...data].sort(
        (a, b) =>
          getPrice(a.price) - getPrice(b.price)
      );

      setAllProducts(sortedProducts);
    } catch (error) {
      console.error(
        "Məhsulların yüklənməsində xəta:",
        error
      );

      setAllProducts([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getProducts();
  }, []);

  /*
   * =========================================================
   * MƏHSULLARI QRUPLA
   * =========================================================
   */

  const normalProducts = useMemo(() => {
    return allProducts.filter(
      (item) =>
        getProductType(item) === "normal"
    );
  }, [allProducts]);

  const specialProducts = useMemo(() => {
    return allProducts.filter(
      (item) =>
        getProductType(item) === "special"
    );
  }, [allProducts]);

  const monthlyProducts = useMemo(() => {
    return allProducts.filter(
      (item) =>
        getProductType(item) === "monthly"
    );
  }, [allProducts]);

  /*
   * =========================================================
   * MƏHSUL SEÇİMİ
   * =========================================================
   */

  const toggleProduct = (product) => {
    if (!product?._id) {
      console.error(
        "Məhsulda MongoDB _id yoxdur:",
        product
      );

      return;
    }

    const productId = String(product._id);

    const exists = selectedProducts.some(
      (item) =>
        String(item?._id) === productId
    );

    if (exists) {
      setSelectedProducts((prev) =>
        prev.filter(
          (item) =>
            String(item?._id) !== productId
        )
      );
    } else {
      setSelectedProducts((prev) => [
        ...prev,
        product,
      ]);
    }
  };

  /*
   * =========================================================
   * SEÇİLİB?
   * =========================================================
   */

  const isSelected = (product) => {
    if (!product?._id) {
      return false;
    }

    const productId = String(product._id);

    return selectedProducts.some(
      (item) =>
        String(item?._id) === productId
    );
  };

  /*
   * =========================================================
   * AYLIQ SEÇİLİB?
   * =========================================================
   */

  // =====================================================
  // SCROLL ARROW (telefon / iPad): cədvəlin sonuna qədər
  // =====================================================

  const tableWrapRef = useRef(null);
  const scrollArrowBtnRef = useRef(null);
  const autoScrollRafRef = useRef(null);
  const autoScrollingRef = useRef(false);

  // Yalnız "görünür/gizli" state-dədir. Oxun hündürlüyü (top)
  // scroll zamanı state ilə yox, birbaşa DOM-a yazılır ki,
  // bütün Pubg komponenti hər scroll kadrında yenidən render olmasın.
  const [arrowVisible, setArrowVisible] = useState(false);
  const arrowTopRef = useRef(110);
  const [autoScrolling, setAutoScrolling] = useState(false);

  // aşağıdakı sabit sifariş panelinin real hündürlüyü
  const getOrderBarSpace = () => {
    const bar = document.querySelector(".pubg-order-bar");
    return bar ? bar.offsetHeight : 96;
  };

  useEffect(() => {
    let ticking = false;

    const update = () => {
      ticking = false;

      const el = tableWrapRef.current;
      if (!el) return;

      const rect = el.getBoundingClientRect();
      const vh = window.innerHeight;
      const visibleBottom = vh - getOrderBarSpace();

      const tableStarted = rect.top < vh - 140;
      const endReached = rect.bottom <= visibleBottom + 8;

      const visible = tableStarted && !endReached;

      const top = Math.round(
        Math.min(
          Math.max(rect.top + 64, 96),
          visibleBottom - 130
        )
      );

      arrowTopRef.current = top;

      if (scrollArrowBtnRef.current) {
        scrollArrowBtnRef.current.style.top = `${top}px`;
      }

      setArrowVisible(visible);
    };

    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    };

    update();

    window.addEventListener("scroll", onScroll, {
      passive: true,
    });
    window.addEventListener("resize", onScroll);

    // cədvəl yükləndikdən sonra hündürlük dəyişir
    const interval = setInterval(update, 1000);

    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
      clearInterval(interval);
    };
  }, [loading]);

  const stopAutoScroll = () => {
    autoScrollingRef.current = false;
    setAutoScrolling(false);

    if (autoScrollRafRef.current) {
      cancelAnimationFrame(autoScrollRafRef.current);
      autoScrollRafRef.current = null;
    }
  };

  const startAutoScroll = () => {
    if (autoScrollingRef.current) {
      stopAutoScroll();
      return;
    }

    autoScrollingRef.current = true;
    setAutoScrolling(true);

    const SPEED = 320; // piksel / saniyə (yavaş)
    let last = performance.now();
    let pos = window.scrollY;

    const cancelOnUser = (e) => {
      if (
        e &&
        e.target &&
        scrollArrowBtnRef.current &&
        scrollArrowBtnRef.current.contains(e.target)
      ) {
        return;
      }
      finish();
    };

    const finish = () => {
      window.removeEventListener("wheel", cancelOnUser);
      window.removeEventListener("touchstart", cancelOnUser);
      window.removeEventListener("keydown", cancelOnUser);
      stopAutoScroll();
    };

    window.addEventListener("wheel", cancelOnUser, {
      passive: true,
    });
    window.addEventListener("touchstart", cancelOnUser, {
      passive: true,
    });
    window.addEventListener("keydown", cancelOnUser);

    const step = (now) => {
      if (!autoScrollingRef.current) {
        finish();
        return;
      }

      const el = tableWrapRef.current;
      if (!el) {
        finish();
        return;
      }

      const dt = Math.min(now - last, 50);
      last = now;

      const rect = el.getBoundingClientRect();
      const remaining =
        rect.bottom - (window.innerHeight - getOrderBarSpace());

      if (remaining <= 1) {
        finish();
        return;
      }

      // istifadəçi əl ilə sürüşdürübsə, mövqeyi sinxronlaşdır
      if (Math.abs(window.scrollY - pos) > 3) {
        pos = window.scrollY;
      }

      pos += Math.min((SPEED * dt) / 1000, remaining);
      window.scrollTo(0, pos);

      autoScrollRafRef.current =
        requestAnimationFrame(step);
    };

    autoScrollRafRef.current = requestAnimationFrame(step);
  };

  useEffect(() => {
    return () => {
      if (autoScrollRafRef.current) {
        cancelAnimationFrame(autoScrollRafRef.current);
      }
    };
  }, []);

  useEffect(() => {
    if (modalOpen || monthlyWarningOpen) {
      stopAutoScroll();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modalOpen, monthlyWarningOpen]);

  const hasMonthlySelection = () => {
    return selectedProducts.some(
      (item) =>
        getProductType(item) === "monthly"
    );
  };

  /*
   * =========================================================
   * ÜMUMİ QİYMƏT
   * =========================================================
   */

  const selectedTotal = useMemo(() => {
    return selectedProducts.reduce(
      (total, item) =>
        total + getPrice(item.price),
      0
    );
  }, [selectedProducts]);

  const finalTotal =
    selectedTotal *
    Math.max(
      1,
      Number(modalCount) || 1
    );

  /*
   * =========================================================
   * MƏHSUL ADLARI
   * =========================================================
   */

  const selectedNames = useMemo(() => {
    return selectedProducts.map((item) => {
      let name = String(item.title || "");

      const type = getProductType(item);

      if (type === "special") {
        name +=
          " — 1-3 dəqiqə ərzində yükləmə";
      }

      return name;
    });
  }, [selectedProducts]);

  /*
   * =========================================================
   * SİFARİŞİ LƏĞV ET
   * =========================================================
   */

  const cancelSelectedOrder = () => {
    setSelectedProducts([]);
    setMonthlyWarningOpen(false);
  };

  /*
   * =========================================================
   * MODALI AÇ
   * =========================================================
   */

  const openMultiModal = () => {
    if (selectedProducts.length === 0) {
      alert("Ən az 1 məhsul seçin!");
      return;
    }

    if (hasMonthlySelection()) {
      setMonthlyWarningOpen(true);
      return;
    }

    openOrderModal();
  };

  /*
   * =========================================================
   * ORDER MODAL
   * =========================================================
   */

  const openOrderModal = () => {
    /*
     * iPhone Safari modal açılarkən səhifəni
     * başqa yerə sürüşdürməsin.
     */
    savedScrollPosition.current =
      window.scrollY || 0;

    setModalCount(1);
    setUserId("");
    setPhotoFile(null);
    setUploadStatus("Qəbz atılmayıb");

    setMonthlyWarningOpen(false);
    setModalOpen(true);
  };

  /*
   * =========================================================
   * MODAL BODY SCROLL LOCK
   * =========================================================
   */

  useEffect(() => {
    const isAnyModalOpen =
      modalOpen || monthlyWarningOpen;

    anyModalOpenRef.current = isAnyModalOpen;

    if (isAnyModalOpen) {
      setViewportHeight(
        window.visualViewport
          ? window.visualViewport.height
          : window.innerHeight
      );
    }

    if (!isAnyModalOpen) {
      document.documentElement.classList.remove(
        "pubg-modal-open"
      );

      document.body.classList.remove(
        "pubg-modal-open"
      );

      document.body.style.removeProperty(
        "top"
      );

      document.body.style.removeProperty(
        "left"
      );

      document.body.style.removeProperty(
        "right"
      );

      document.body.style.removeProperty(
        "position"
      );

      document.body.style.removeProperty(
        "width"
      );

      return;
    }

    savedScrollPosition.current =
      window.scrollY || 0;

    document.documentElement.classList.add(
      "pubg-modal-open"
    );

    document.body.classList.add(
      "pubg-modal-open"
    );

    /*
     * Body-ni cari scroll mövqeyində kilidləyirik.
     * Bu, iPhone Safari-də modal açılarkən
     * səhifənin yuxarı-aşağı sıçramasının qarşısını alır.
     */
    document.body.style.position = "fixed";

    document.body.style.top =
      `-${savedScrollPosition.current}px`;

    document.body.style.left = "0";
    document.body.style.right = "0";
    document.body.style.width = "100%";

    return () => {
      document.documentElement.classList.remove(
        "pubg-modal-open"
      );

      document.body.classList.remove(
        "pubg-modal-open"
      );

      document.body.style.removeProperty(
        "top"
      );

      document.body.style.removeProperty(
        "left"
      );

      document.body.style.removeProperty(
        "right"
      );

      document.body.style.removeProperty(
        "position"
      );

      document.body.style.removeProperty(
        "width"
      );
    };
  }, [
    modalOpen,
    monthlyWarningOpen,
  ]);

  /*
   * =========================================================
   * MODALI BAĞLA
   * =========================================================
   */

  const closeModal = () => {
    setModalOpen(false);

    setSelectedProducts([]);
    setModalCount(1);
    setUserId("");
    setPhotoFile(null);
    setUploadStatus("Qəbz atılmayıb");

    /*
     * Safari body fixed vəziyyətindən çıxdıqdan sonra
     * əvvəlki scroll mövqeyini bərpa edir.
     */
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        window.scrollTo({
          top: savedScrollPosition.current,
          left: 0,
          behavior: "instant",
        });
      });
    });
  };

  /*
   * =========================================================
   * AYLIQ XƏBƏRDARLIĞI
   * =========================================================
   */

  const handleMonthlyAgree = () => {
    setMonthlyWarningOpen(false);
    openOrderModal();
  };

  const handleMonthlyReject = () => {
    cancelSelectedOrder();
  };

  /*
   * =========================================================
   * FOTO SEÇ
   * =========================================================
   */

  const handlePhotoChange = (event) => {
    const file =
      event.target.files?.[0];

    if (file) {
      setPhotoFile(file);
      setUploadStatus(
        `✅ ${file.name}`
      );
    } else {
      setPhotoFile(null);
      setUploadStatus(
        "Qəbz atılmayıb"
      );
    }
  };

  /*
   * =========================================================
   * IPHONE SAFARI / SİFARİŞ DÜYMƏSİ TOUCH HANDLER
   * =========================================================
   */

  const handleOrderTouchStart = (event) => {
    if (selectedProducts.length === 0) {
      return;
    }

    const touch =
      event.touches?.[0];

    if (!touch) {
      return;
    }

    orderTouchStartYRef.current =
      touch.clientY;

    orderTouchStartXRef.current =
      touch.clientX;

    orderTouchMovedRef.current =
      false;
  };

  const handleOrderTouchMove = (event) => {
    const touch =
      event.touches?.[0];

    if (!touch) {
      return;
    }

    const deltaY = Math.abs(
      touch.clientY -
        orderTouchStartYRef.current
    );

    const deltaX = Math.abs(
      touch.clientX -
        orderTouchStartXRef.current
    );

    if (
      deltaY > 10 ||
      deltaX > 10
    ) {
      orderTouchMovedRef.current =
        true;
    }
  };

  const handleOrderTouchEnd = (event) => {
    if (selectedProducts.length === 0) {
      return;
    }

    /*
     * Barmaq hərəkət edibsə bu scroll-dur,
     * sifariş tap-i deyil.
     */
    if (orderTouchMovedRef.current) {
      orderTouchMovedRef.current =
        false;

      return;
    }

    /*
     * Safari-də eyni toxunuşdan sonra gələn
     * synthetic click ikinci dəfə modalı açmağa
     * cəhd etməsin.
     */
    if (orderTouchHandledRef.current) {
      return;
    }

    orderTouchHandledRef.current =
      true;

    /*
     * Əsas əməliyyatı ilk touchend-də edirik.
     *
     * Beləliklə Safari-nin toolbar/visualViewport
     * keçidi onClick hadisəsini gözləmədən modal açılır.
     */
    event.preventDefault();

    openMultiModal();

    window.setTimeout(() => {
      orderTouchHandledRef.current =
        false;
    }, 500);
  };

  const handleOrderTouchCancel = () => {
    /*
     * iPhone Safari alt toolbar-ı açılanda fixed düymə yerini
     * dəyişir və toxunuş touchend əvəzinə touchcancel ilə
     * bitə bilər. Barmaq hərəkət etməyibsə bunu tap sayırıq.
     */
    const wasMoved =
      orderTouchMovedRef.current;

    orderTouchMovedRef.current =
      false;

    if (
      wasMoved ||
      selectedProducts.length === 0 ||
      orderTouchHandledRef.current
    ) {
      return;
    }

    orderTouchHandledRef.current =
      true;

    openMultiModal();

    window.setTimeout(() => {
      orderTouchHandledRef.current =
        false;
    }, 500);
  };

  /*
   * =========================================================
   * SİFARİŞ GÖNDƏR
   * =========================================================
   */

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!photoFile) {
      alert(
        "Zəhmət olmasa qəbzin şəklini yükləyin!"
      );

      return;
    }

    if (!userId.trim()) {
      alert(
        "Zəhmət olmasa PUBG ID-ni daxil edin!"
      );

      return;
    }

    if (selectedProducts.length === 0) {
      alert(
        "Ən az 1 məhsul seçilməlidir!"
      );

      return;
    }

    setSubmitting(true);

    const formData =
      new FormData();

    formData.append(
      "title",
      selectedNames.join(" + ")
    );

    formData.append(
      "price",
      finalTotal.toFixed(2)
    );

    formData.append(
      "count",
      String(modalCount)
    );

    formData.append(
      "description",
      `${selectedProducts.length} məhsul birlikdə seçildi`
    );

    formData.append(
      "pubgId",
      userId.trim()
    );

    formData.append(
      "photo",
      photoFile
    );

    try {
      const response =
        await fetch(
          API_SUBMIT,
          {
            method: "POST",
            body: formData,
            headers: {
              Accept: "*/*",
            },
          }
        );

      if (!response.ok) {
        let errorMessage =
          `HTTP ${response.status}`;

        try {
          const errorData =
            await response.json();

          if (errorData?.message) {
            errorMessage =
              errorData.message;
          }
        } catch (jsonError) {
          console.error(
            "Error response JSON deyil:",
            jsonError
          );
        }

        throw new Error(
          errorMessage
        );
      }

      alert(
        "Sifarişiniz qəbul olundu!\n\n" +
        "⏱ Yüklənmə müddəti: 1–10 dəq " +
        "(bəzən 30 dəq-dək çəkə bilər).\n\n" +
        "‼️ Qeyd: Balansın oturması üçün " +
        "oyuna çıx-gir edin."
      );

      closeModal();

      await getProducts();
    } catch (error) {
      console.error(
        "Sifariş göndərmə xətası:",
        error
      );

      alert(
        "Çekiniz göndərilmədi, " +
        "sol aşağıdakı mavi butona basıb " +
        "qəbz və ID-nizi canlı çat vasitəsilə göndərin."
      );
    } finally {
      setSubmitting(false);
    }
  };

  /*
   * =========================================================
   * ESC
   * =========================================================
   */

  useEffect(() => {
    const handleEscape = (event) => {
      if (event.key === "Escape") {
        if (modalOpen) {
          closeModal();
        }

        if (monthlyWarningOpen) {
          setMonthlyWarningOpen(false);
        }
      }
    };

    document.addEventListener(
      "keydown",
      handleEscape
    );

    return () => {
      document.removeEventListener(
        "keydown",
        handleEscape
      );
    };
  }, [
    modalOpen,
    monthlyWarningOpen,
  ]);

  /*
   * =========================================================
   * PRODUCT ROW
   * =========================================================
   */

  const ProductRow = ({
    item,
    type,
    index,
  }) => {
    const selected =
      isSelected(item);

    const ucAmount =
      getUcAmount(item);

    let deliveryText = "";

    if (type === "special") {
      deliveryText =
        "1-3 dəqiqə ərzində yükləmə";
    } else if (
      ucAmount > 0 &&
      ucAmount >= 3850
    ) {
      deliveryText =
        "1-30 dəqiqə ərzində yükləmə";
    }

    const finalTitle =
      deliveryText
        ? `${item.title} — ${deliveryText}`
        : item.title;

    const handleRowClick = () => {
      /*
       * Əgər toxunma hadisəsi artıq məhsulu seçibsə,
       * Safari-nin ardınca göndərdiyi click ikinci dəfə
       * toggle etməsin.
       */
      if (
        touchHandledRef.current
      ) {
        return;
      }

      toggleProduct(item);
    };

    const handleRowTouchStart = (
      event
    ) => {
      if (
        event.target.closest(
          "button, input, a, label"
        )
      ) {
        return;
      }

      const touch =
        event.touches?.[0];

      if (!touch) {
        return;
      }

      touchStartYRef.current =
        touch.clientY;

      touchStartXRef.current =
        touch.clientX;

      touchMovedRef.current =
        false;
    };

    const handleRowTouchMove = (
      event
    ) => {
      const touch =
        event.touches?.[0];

      if (!touch) {
        return;
      }

      const deltaY = Math.abs(
        touch.clientY -
          touchStartYRef.current
      );

      const deltaX = Math.abs(
        touch.clientX -
          touchStartXRef.current
      );

      /*
       * 10px-dən çox hərəkət varsa bunu
       * məhsul seçimi yox, SCROLL hesab edirik.
       */
      if (
        deltaY > 10 ||
        deltaX > 10
      ) {
        touchMovedRef.current =
          true;
      }
    };

    const handleRowTouchEnd = (
      event
    ) => {
      if (
        event.target.closest(
          "button, input, a, label"
        )
      ) {
        return;
      }

      /*
       * Əgər istifadəçi barmağını hərəkət etdiribsə,
       * deməli scroll edib.
       *
       * Heç bir məhsul seçilmir.
       */
      if (
        touchMovedRef.current
      ) {
        touchMovedRef.current =
          false;

        return;
      }

      /*
       * Safari click hadisəsini sonra göndərməsin deyə
       * touch seçimindən sonra qısa müddətlik click-i bloklayırıq.
       */
      if (
        touchHandledRef.current
      ) {
        return;
      }

      touchHandledRef.current =
        true;

      toggleProduct(item);

      window.setTimeout(() => {
        touchHandledRef.current =
          false;
      }, 450);
    };

    const handleRowTouchCancel =
      () => {
        touchMovedRef.current =
          false;
      };

    return (
      <tr
        key={String(item._id)}
        onClick={
          handleRowClick
        }
        onTouchStart={
          handleRowTouchStart
        }
        onTouchMove={
          handleRowTouchMove
        }
        onTouchEnd={
          handleRowTouchEnd
        }
        onTouchCancel={
          handleRowTouchCancel
        }
        className={`
          cursor-pointer
          touch-manipulation
          select-none
          transition-all
          duration-150
          border-b
          border-gray-200/60
          dark:border-white/[0.06]

          ${
            selected
              ? `
                bg-amber-500/[0.10]
                shadow-[inset_3px_0_0_#ffb800]
                dark:bg-gradient-to-r
                dark:from-amber-500/15
                dark:to-purple-500/10
              `
              : `
                bg-white
                hover:bg-amber-50
                dark:bg-white/[0.018]
                dark:hover:bg-amber-500/[0.045]
              `
          }
        `}
      >
        {/* NUMBER */}

        <td
          className="
            w-[29px]
            px-[2px]
            py-2
            text-center

            sm:w-[62px]
            sm:px-3.5
            sm:py-3
          "
        >
          <span
            className="
              inline-flex
              h-[21px]
              w-[21px]
              items-center
              justify-center
              rounded-[6px]

              border
              border-amber-500/25
              bg-amber-500/[0.08]

              text-[8px]
              font-black
              text-amber-500

              sm:h-[34px]
              sm:w-[34px]
              sm:rounded-[10px]
              sm:text-xs

              dark:text-amber-400
            "
          >
            {index}
          </span>
        </td>

        {/* PRODUCT */}

        <td
          className="
            min-w-0
            px-1.5
            py-2

            sm:px-3.5
            sm:py-3
          "
        >
          <div className="min-w-0">
            <div
              className="
                break-words
                text-[10px]
                font-extrabold
                leading-[1.3]
                text-gray-800

                sm:text-sm
                sm:leading-[1.45]

                dark:text-gray-100
              "
            >
              {finalTitle}
            </div>

            <div
              className="
                mt-[2px]
                text-[7px]
                font-extrabold
                uppercase
                tracking-[.45px]
                text-gray-400

                sm:mt-[3px]
                sm:text-[9px]
                sm:tracking-[.8px]
                sm:text-gray-500
              "
            >
              {type === "special"
                ? "XÜSUSİ UC PAKETİ"
                : type === "monthly"
                  ? "AYLIQ UC PAKETİ"
                  : "UC PAKETİ"}
            </div>
          </div>
        </td>

        {/* PRICE */}

        <td
          className="
            w-[52px]
            px-1
            py-2
            text-right
            text-[10px]
            font-black
            text-amber-500

            sm:w-[120px]
            sm:px-3.5
            sm:py-3
            sm:text-[15px]

            dark:text-amber-400
          "
        >
          {String(item.price).replace(
            /\s*AZN\s*$/i,
            ""
          )}{" "}
          AZN
        </td>

        {/* CHECK */}

        <td
          className="
            w-[31px]
            px-0.5
            py-2
            text-center

            sm:w-[68px]
            sm:py-3
          "
        >
          <span
            className={`
              inline-flex
              h-[20px]
              w-[20px]
              items-center
              justify-center
              rounded-[6px]
              border
              transition-all
              duration-150

              sm:h-[30px]
              sm:w-[30px]
              sm:rounded-[10px]

              ${
                selected
                  ? `
                    border-amber-300
                    bg-gradient-to-br
                    from-yellow-300
                    to-orange-500
                    text-[#050505]
                    shadow-[0_0_14px_rgba(255,184,0,.40)]
                    scale-[1.04]
                  `
                  : `
                    border-gray-300
                    bg-gray-50
                    text-transparent

                    dark:border-[#231842]
                    dark:bg-[#0D081D]
                  `
              }
            `}
          >
            <span
              className="
                text-[8px]
                font-black
                sm:text-[11px]
              "
            >
              ✓
            </span>
          </span>
        </td>
      </tr>
    );
  };

  /*
   * =========================================================
   * SECTION HEADER
   * =========================================================
   */

  const SectionRow = ({
    icon,
    children,
  }) => {
    return (
      <tr>
        <td
          colSpan="4"
          className="
            border-y
            border-amber-500/25
            bg-amber-500/10
            px-2
            py-2.5

            sm:px-3.5
            sm:py-3

            dark:bg-gradient-to-r
            dark:from-amber-500/[0.12]
            dark:to-purple-500/[0.08]
          "
        >
          <div
            className="
              flex
              items-center
              gap-1.5
              text-[7px]
              font-black
              uppercase
              tracking-[.45px]
              text-amber-600

              sm:gap-2
              sm:text-[11px]
              sm:tracking-[.8px]
              dark:text-amber-400
            "
          >
            <span
              className="
                inline-flex
                h-[21px]
                w-[21px]
                shrink-0
                items-center
                justify-center
                rounded-[6px]
                bg-gradient-to-br
                from-yellow-300
                to-orange-500
                text-[10px]
                text-black

                sm:h-7
                sm:w-7
                sm:rounded-[9px]
                sm:text-sm
              "
            >
              {icon}
            </span>

            <span>
              {children}
            </span>
          </div>
        </td>
      </tr>
    );
  };

  let rowNumber = 1;

  return (
    <>
      {/* =====================================================
          SAFARI MOBILE CSS
      ====================================================== */}

      <style>
        {`
          html.pubg-modal-open,
          html.pubg-modal-open body {
            overscroll-behavior: none !important;
            overflow: hidden !important;
          }

          body.pubg-modal-open {
            overscroll-behavior: none !important;
            touch-action: manipulation;
          }

          /*
           * iPhone Safari input zoom problemi.
           * 16px-dən aşağı input font-size Safari-də
           * avtomatik zoom yarada bilər.
           */
          @media (max-width: 767px) {
            input,
            textarea,
            select {
              font-size: 16px;
            }
          }

          /*
           * iPhone Safari tap highlight-i söndürürük.
           */
          button {
            -webkit-tap-highlight-color: transparent;
          }

          /*
           * iPhone Safari: ekranın ən alt hissəsinə (alt toolbar zonası)
           * ilk toxunuş səhifəyə yox, Safari-nin toolbar-ını açmağa
           * gedir. Bu səbəbdən "SİFARİŞİ TƏSDİQLƏ" düyməsi ilk toxunuşda
           * işləmirdi. Paneli bu zonadan yuxarı qaldırırıq.
           * Qaldırma miqdarını dəyişmək üçün --pubg-ios-lift istifadə edin.
           */
          :root {
            --pubg-ios-lift: 56px;
          }

          @supports (-webkit-touch-callout: none) {
            @media (display-mode: browser) {
              .pubg-order-bar {
                padding-bottom: calc(
                  env(safe-area-inset-bottom, 0px) +
                    var(--pubg-ios-lift)
                ) !important;
              }

              .pubg-products-pad {
                padding-bottom: calc(
                  115px + var(--pubg-ios-lift)
                ) !important;
              }
            }
          }

          :root {
            --pubg-safe-bottom:
              env(safe-area-inset-bottom, 0px);

            --pubg-safe-top:
              env(safe-area-inset-top, 0px);
          }
        `}
      </style>

      <main
        className="
          min-h-screen
          overflow-x-hidden

          bg-gray-50
          text-gray-900

          [background-image:radial-gradient(circle_at_15%_10%,rgba(139,92,246,.06),transparent_28%),radial-gradient(circle_at_85%_20%,rgba(6,182,212,.04),transparent_24%),linear-gradient(180deg,#f9fafb_0%,#f3f4f6_48%,#ffffff_100%)]

          font-['Segoe_UI',sans-serif]

          dark:bg-[#040209]
          dark:text-gray-100
          dark:[background-image:radial-gradient(circle_at_15%_10%,rgba(139,92,246,.10),transparent_28%),radial-gradient(circle_at_85%_20%,rgba(6,182,212,.06),transparent_24%),linear-gradient(180deg,#040209_0%,#07030f_48%,#040209_100%)]
        "
      >
        {/* =====================================================
            BANNER
        ====================================================== */}

        <section className="px-2 pt-2 sm:px-3 sm:pt-3">
          <div
            className="
              mx-auto
              w-full
              max-w-7xl
              overflow-hidden
              rounded-2xl
              border
              border-gray-200
              bg-white
              shadow-[0_10px_35px_rgba(0,0,0,0.08)]

              sm:rounded-3xl

              dark:border-[#231842]
              dark:bg-[#0D081D]
              dark:shadow-[0_0_35px_rgba(139,92,246,0.30)]
            "
          >
            <a
              href={WHATSAPP}
              target="_blank"
              rel="noopener noreferrer"
              className="group block w-full"
            >
              <img
                src={PubgH}
                alt="PUBG UC"
                className="
                  block
                  h-auto
                  max-h-[190px]
                  w-full
                  object-cover
                  transition-transform
                  duration-500
                  group-hover:scale-[1.01]

                  sm:max-h-[240px]

                  lg:max-h-[300px]
                "
              />
            </a>
          </div>
        </section>

        {/* =====================================================
            INFO
        ====================================================== */}

        <section
          className="
            flex
            justify-center
            px-3
            pt-3
            text-center
          "
        >
          <p
            className="
              m-0
              text-[11px]
              leading-5
              text-gray-700

              sm:text-sm

              dark:text-white
            "
          >
            Hər hansı sualınız yaranarsa sol aşağıdakı
            canlı çat vasitəsilə əlaqə saxlayın.
          </p>
        </section>

        {/* =====================================================
            WORK TIME
        ====================================================== */}

        <section
          className="
            flex
            justify-center
            overflow-hidden
            px-3
            pt-2.5
            text-center
          "
        >
          <div
            className="
              w-full
              max-w-5xl
              overflow-hidden
            "
          >
            <p
              className="
                mx-auto
                inline-block
                whitespace-nowrap
                rounded-lg
                border
                border-gray-200
                bg-white
                px-3
                py-1.5
                text-[11px]
                font-bold
                text-gray-800
                shadow-sm

                sm:px-4
                sm:py-2
                sm:text-sm

                dark:border-white/[0.13]
                dark:bg-[#0A0513]
                dark:text-white
              "
            >
              İş saatımız 11:00-04:30
            </p>
          </div>
        </section>

        {/* =====================================================
            VIDEO
        ====================================================== */}

        <section>
          <div
            className="
              mx-auto
              mt-4
              aspect-video
              w-[calc(100%-24px)]
              max-w-[1000px]
              overflow-hidden
              rounded-[14px]
              border
              border-gray-200
              bg-white
              shadow-[0_10px_35px_rgba(0,0,0,.10)]

              sm:mt-[18px]
              sm:rounded-[17px]

              dark:border-white/[0.06]
              dark:bg-[#0D081D]
              dark:shadow-[0_10px_35px_rgba(0,0,0,.35),0_0_25px_rgba(139,92,246,.06)]
            "
          >
            <iframe
              src="https://www.youtube.com/embed/hGLqd3qfyQs?rel=0&modestbranding=1"
              title="YouTube Video"
              loading="lazy"
              className="
                h-full
                w-full
                border-0
              "
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
            />
          </div>
        </section>

        {/* =====================================================
            PRODUCTS
        ====================================================== */}

        <section>
          <div
            className="
              pubg-products-pad
              mx-auto
              my-4
              w-full
              max-w-[1400px]
              px-2
              pb-[105px]

              sm:px-4
              sm:pb-[115px]
            "
          >
            {/* FILTER */}

            <div
              className="
                mb-3
                flex
                flex-wrap
                gap-2
              "
            >
              <button
                type="button"
                className="
                  inline-flex
                  min-h-[38px]
                  flex-1
                  items-center
                  justify-center
                  gap-1.5
                  rounded-[11px]
                  border
                  border-yellow-300
                  bg-gradient-to-br
                  from-yellow-300
                  to-orange-500
                  px-2
                  py-1.5
                  text-[9px]
                  font-black
                  tracking-[.25px]
                  text-[#08050b]
                  shadow-[0_0_18px_rgba(255,184,0,.22)]

                  sm:min-h-[42px]
                  sm:flex-none
                  sm:gap-2
                  sm:rounded-[14px]
                  sm:px-[18px]
                  sm:py-2
                  sm:text-xs
                "
              >
                <span>🎮</span>
                UC Paketləri
              </button>
            </div>

            <div
              className="
                mt-3
                mb-6
                flex
                items-start
                gap-2
                rounded-xl
                border
                border-rose-500/25
                p-2.5
                text-[16px]
                leading-[1.55]
                text-rose-800

                sm:mt-4
                sm:gap-3
                sm:rounded-2xl
                sm:p-[15px_17px]
                sm:text-base
                sm:leading-[1.65]

                dark:bg-gradient-to-br
                dark:from-red-900/[0.16]
                dark:to-pink-950/[0.10]
                dark:text-rose-100/90
              "
            >
              <span
                className="
                  mt-0.5
                  shrink-0
                  text-sm
                  text-rose-500

                  sm:text-lg
                  dark:text-rose-400
                "
              >
                ⚠
              </span>

              <p className="m-0">
                3-cü şəxslərdən və ya oğurluq pullardan
                istifadə edilərsə, Azərbaycan Respublikası
                qanunvericiliyinə uyğun olaraq məsuliyyət
                daşıyırsınız. 16 yaşdan aşağı şəxslərin
                ödəniş etməsinə icazə verilmir.
              </p>
            </div>

            {/* TABLE */}

            <div
              ref={tableWrapRef}
              className="
                w-full
                overflow-hidden
                rounded-xl
                border
                border-gray-200

                sm:rounded-2xl

                dark:border-[#231842]
                dark:bg-gradient-to-b
                dark:from-[#0D081D]/95
                dark:to-[#06040c]/98
                dark:shadow-[0_20px_50px_rgba(0,0,0,.60),0_0_28px_rgba(139,92,246,.08)]
              "
            >
              <div className="w-full">
                <table
                  className="
                    w-full
                    table-fixed
                    border-collapse
                  "
                >
                  <thead>
                    <tr className="border-b border-gray-200 dark:border-white/[0.12]">
                      {/* # */}

                      <th
                        className="
                          w-[29px]
                          bg-gray-100
                          px-1
                          py-2
                          text-center
                          text-[8px]
                          font-black
                          uppercase
                          tracking-[.35px]
                          text-gray-600

                          sm:w-[62px]
                          sm:px-3.5
                          sm:py-[15px]
                          sm:text-[11px]
                          sm:tracking-[.65px]

                          dark:bg-gradient-to-br
                          dark:from-[#171125]
                          dark:to-[#251b3b]
                          dark:text-gray-300
                        "
                      >
                        #
                      </th>

                      {/* PRODUCT */}

                      <th
                        className="
                          bg-gray-100
                          px-1.5
                          py-2
                          text-left
                          text-[8px]
                          font-black
                          uppercase
                          tracking-[.35px]
                          text-gray-600

                          sm:px-3.5
                          sm:py-[15px]
                          sm:text-[11px]
                          sm:tracking-[.65px]

                          dark:bg-gradient-to-br
                          dark:from-[#171125]
                          dark:to-[#251b3b]
                          dark:text-gray-300
                        "
                      >
                        Məhsul
                      </th>

                      {/* PRICE */}

                      <th
                        className="
                          w-[52px]
                          bg-gray-100
                          px-1
                          py-2
                          text-right
                          text-[8px]
                          font-black
                          uppercase
                          tracking-[.35px]
                          text-gray-600

                          sm:w-[120px]
                          sm:px-3.5
                          sm:py-[15px]
                          sm:text-[11px]
                          sm:tracking-[.65px]

                          dark:bg-gradient-to-br
                          dark:from-[#171125]
                          dark:to-[#251b3b]
                          dark:text-gray-300
                        "
                      >
                        Qiymət
                      </th>

                      {/* SELECT */}

                      <th
                        className="
                          w-[31px]
                          bg-gray-100
                          px-0.5
                          py-2
                          text-center
                          text-[8px]
                          font-black
                          uppercase
                          tracking-[.35px]
                          text-gray-600

                          sm:w-[68px]
                          sm:py-[15px]
                          sm:text-[11px]
                          sm:tracking-[.65px]

                          dark:bg-gradient-to-br
                          dark:from-[#171125]
                          dark:to-[#251b3b]
                          dark:text-gray-300
                        "
                      >
                        Seç
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    {/* LOADING */}

                    {loading && (
                      <tr>
                        <td
                          colSpan="4"
                          className="
                            px-2
                            py-7
                            text-center
                            text-[11px]
                            text-gray-500

                            sm:px-4
                            sm:py-[34px]
                            sm:text-sm

                            dark:text-white/70
                          "
                        >
                          Yüklənir...
                        </td>
                      </tr>
                    )}

                    {/* EMPTY */}

                    {!loading &&
                      allProducts.length === 0 && (
                        <tr>
                          <td
                            colSpan="4"
                            className="
                              px-2
                              py-7
                              text-center
                              text-[10px]
                              text-gray-500

                              sm:px-4
                              sm:py-[34px]
                              sm:text-sm

                              dark:text-white/70
                            "
                          >
                            <div
                              className="
                                mb-2
                                text-xl
                                sm:text-2xl
                              "
                            >
                              📦
                            </div>

                            Məhsullar yüklənmədi.
                            <br />

                            <span>
                              Qiymət siyahısı açılmazsa{" "}
                            </span>

                            <a
                              href={WHATSAPP}
                              target="_blank"
                              rel="noreferrer"
                              className="
                                font-black
                                text-amber-500
                                dark:text-amber-400
                              "
                            >
                              WHATSAPP
                            </a>

                            <span>
                              {" "}
                              vasitəsilə əlaqə saxlayın.
                            </span>
                          </td>
                        </tr>
                      )}

                    {/* NORMAL */}

                    {!loading &&
                      normalProducts.map(
                        (item) => (
                          <ProductRow
                            key={String(
                              item._id
                            )}
                            item={item}
                            type="normal"
                            index={
                              rowNumber++
                            }
                          />
                        )
                      )}

                    {/* SPECIAL */}

                    {!loading &&
                      specialProducts.length >
                        0 && (
                        <>
                          <SectionRow icon="👑">
                            Xüsusi UC paketləri
                          </SectionRow>

                          {specialProducts.map(
                            (item) => (
                              <ProductRow
                                key={String(
                                  item._id
                                )}
                                item={item}
                                type="special"
                                index={
                                  rowNumber++
                                }
                              />
                            )
                          )}
                        </>
                      )}

                    {/* MONTHLY */}

                    {!loading &&
                      monthlyProducts.length >
                        0 && (
                        <>
                          <SectionRow icon="📅">
                            Aylıq UC paketləri Oyunda
                            “MESAJLAR” bölümünə düşür,
                            iadeye sayılmır.
                          </SectionRow>

                          {monthlyProducts.map(
                            (item) => (
                              <ProductRow
                                key={String(
                                  item._id
                                )}
                                item={item}
                                type="monthly"
                                index={
                                  rowNumber++
                                }
                              />
                            )
                          )}
                        </>
                      )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </section>

        {/* =====================================================
            SCROLL ARROW (yalnız telefon / iPad)
        ====================================================== */}

        {arrowVisible &&
          !loading &&
          !modalOpen &&
          !monthlyWarningOpen && (
            <button
              ref={scrollArrowBtnRef}
              type="button"
              onClick={startAutoScroll}
              aria-label="Cədvəlin sonuna qədər sürüşdür"
              className="
                fixed
                right-2
                z-[850]
                flex
                flex-col
                items-end
                gap-1.5
                sm:right-4
                [@media(hover:hover)_and_(pointer:fine)]:hidden
              "
              style={{ top: arrowTopRef.current }}
            >
              <span
                className="
                  max-w-[150px]
                  rounded-xl
                  border
                  border-yellow-300/60
                  bg-white/95
                  px-2.5
                  py-1.5
                  text-left
                  text-[10px]
                  font-bold
                  leading-snug
                  text-gray-800
                  shadow-[0_6px_20px_rgba(0,0,0,.18)]
                  backdrop-blur
                  sm:max-w-[210px]
                  sm:text-xs
                  dark:border-yellow-400/40
                  dark:bg-[#0D081D]/95
                  dark:text-yellow-100
                "
              >
                {autoScrolling
                  ? "Dayandırmaq üçün toxun"
                  : "💡2 Manata 150 UC paketi axtarırsan? Butona basın"}
              </span>

              <span
                className={`
                  flex
                  h-11
                  w-11
                  items-center
                  justify-center
                  rounded-full
                  border
                  border-yellow-300
                  bg-gradient-to-br
                  from-yellow-300
                  to-orange-500
                  text-xl
                  font-black
                  text-[#08050b]
                  shadow-[0_0_18px_rgba(255,184,0,.45)]
                  sm:h-12
                  sm:w-12
                  ${autoScrolling ? "" : "animate-bounce"}
                `}
              >
                {autoScrolling ? "❚❚" : "↓"}
              </span>
            </button>
          )}

        {/* =====================================================
            FIXED ORDER BAR
        ====================================================== */}

        <div
          className="
            pubg-order-bar
            fixed
            bottom-0
            left-0
            right-0
            z-[900]
            border-t
            border-gray-200
            bg-white/95
            px-2.5
            pt-2.5
            shadow-[0_-8px_30px_rgba(0,0,0,.12)]
            backdrop-blur-xl

            sm:px-4
            sm:py-3

            dark:border-[#231842]
            dark:bg-[#080510]/95
            dark:shadow-[0_-8px_35px_rgba(0,0,0,.55)]
          "
          style={{
            paddingBottom:
              "calc(0.625rem + env(safe-area-inset-bottom, 0px))",
          }}
        >
          <div
            className="
              mx-auto
              flex
              w-full
              max-w-7xl
              items-center
              gap-2
            "
          >
            {/* TOTAL */}

            <div
              className="
                flex
                min-w-0
                flex-1
                items-center
                rounded-xl
                border
                border-gray-200
                bg-gray-50
                px-3
                py-2.5

                sm:px-4
                sm:py-3

                dark:border-[#231842]
                dark:bg-[#0D081D]
              "
            >
              {/* SEÇİLƏNLƏR */}

              <div
                className="
                  min-w-0
                  flex-1
                  overflow-hidden
                "
              >
                <div
                  className="
                    text-[9px]
                    font-black
                    uppercase
                    tracking-[.35px]
                    text-gray-500

                    sm:text-[11px]
                    sm:tracking-[.7px]

                    dark:text-gray-500
                  "
                >
                  Seçilənlər
                </div>

                <div
                  className="
                    mt-0.5
                    whitespace-nowrap
                    text-[10px]
                    font-bold
                    text-gray-700

                    sm:text-xs

                    dark:text-gray-300
                  "
                >
                  {selectedProducts.length} məhsul
                </div>
              </div>

              {/* TOTAL AZN */}

              <div
                className="
                  ml-2
                  shrink-0
                  whitespace-nowrap
                  text-[13px]
                  font-black
                  text-amber-500

                  sm:ml-4
                  sm:text-xl

                  dark:text-amber-400
                "
              >
                {selectedTotal.toFixed(
                  2
                )}{" "}
                AZN
              </div>
            </div>

            {/* ORDER */}

            <button
              type="button"
              onClick={(event) => {
                /*
                 * Əgər touchend artıq modalı açıbsa,
                 * Safari-nin ardınca göndərdiyi click
                 * ikinci dəfə işləməsin.
                 */
                if (
                  orderTouchHandledRef.current
                ) {
                  event.preventDefault();
                  return;
                }

                openMultiModal();
              }}
              onTouchStart={
                handleOrderTouchStart
              }
              onTouchMove={
                handleOrderTouchMove
              }
              onTouchEnd={
                handleOrderTouchEnd
              }
              onTouchCancel={
                handleOrderTouchCancel
              }
              disabled={
                selectedProducts.length === 0
              }
              className="
                inline-flex
                min-h-[47px]
                shrink-0
                touch-manipulation
                items-center
                justify-center
                gap-1.5
                rounded-xl
                border
                border-yellow-300
                bg-gradient-to-br
                from-yellow-300
                via-amber-500
                to-orange-500
                px-3
                text-[9px]
                font-black
                tracking-[.15px]
                text-[#08050b]
                shadow-[0_8px_25px_rgba(255,184,0,.22)]
                transition-all
                duration-200

                [@media(hover:hover)]:hover:-translate-y-0.5
                [@media(hover:hover)]:hover:brightness-110

                disabled:cursor-not-allowed
                disabled:border-gray-300
                disabled:bg-gray-300
                disabled:from-gray-300
                disabled:via-gray-300
                disabled:to-gray-400
                disabled:text-gray-500
                disabled:shadow-none
                disabled:hover:translate-y-0

                sm:min-h-[58px]
                sm:min-w-[260px]
                sm:gap-2.5
                sm:px-6
                sm:text-[12px]
                sm:tracking-[.5px]
              "
            >
              <span
                className="
                  pointer-events-none
                  text-base
                  sm:text-lg
                "
              >
                🛒
              </span>

              <span className="pointer-events-none whitespace-nowrap">
                SİFARİŞİ TƏSDİQLƏ
              </span>
            </button>
          </div>
        </div>

        {/* =====================================================
            MONTHLY WARNING MODAL
        ====================================================== */}

        {monthlyWarningOpen && (
          <div
            className="
              fixed
              inset-0
              z-[9999999999999999]
              flex
              items-center
              justify-center
              overflow-hidden
              bg-black/[0.78]
              p-4
              backdrop-blur-lg
            "
            style={{
              height: viewportHeight
                ? `${viewportHeight}px`
                : "100dvh",

              paddingTop:
                "max(1rem, env(safe-area-inset-top, 0px))",

              paddingBottom:
                "max(1rem, env(safe-area-inset-bottom, 0px))",
            }}
            onClick={(event) => {
              if (
                event.target ===
                event.currentTarget
              ) {
                handleMonthlyReject();
              }
            }}
          >
            <div
              className="
                w-full
                max-w-[520px]
                overflow-hidden
                rounded-[18px]
                border
                border-amber-500/45
                bg-white
                p-5
                text-center
                text-gray-900
                shadow-[0_20px_70px_rgba(0,0,0,.65)]

                sm:p-6

                dark:bg-[#11131a]
                dark:text-white
              "
            >
              <div
                className="
                  mx-auto
                  mb-3.5
                  flex
                  h-[55px]
                  w-[55px]
                  items-center
                  justify-center
                  rounded-full
                  bg-amber-500/[0.12]
                  text-[26px]
                  text-amber-500
                "
              >
                ⚠
              </div>

              <h3
                className="
                  mb-3.5
                  text-lg
                  font-bold

                  sm:text-xl
                "
              >
                Aylıq paket barədə vacib məlumat
              </h3>

              <p
                className="
                  mb-[22px]
                  text-[13px]
                  leading-[1.65]
                  text-gray-600

                  sm:text-[15px]

                  dark:text-gray-200
                "
              >
                Bu paket bəzi hesablarda xəta verib
                yüklənməyə bilər. Yüklənmədikdə eyni
                məbləğdə standart UC vurulmasına
                razısınız?
              </p>

              <div
                className="
                  flex
                  flex-wrap
                  justify-center
                  gap-2.5
                "
              >
                <button
                  type="button"
                  onClick={
                    handleMonthlyReject
                  }
                  className="
                    touch-manipulation
                    rounded-[10px]
                    border
                    border-gray-300
                    bg-gray-100
                    px-4
                    py-2.5
                    text-sm
                    font-bold
                    text-gray-800
                    transition
                    hover:bg-gray-200

                    dark:border-white/[0.18]
                    dark:bg-[#242733]
                    dark:text-white
                    dark:hover:bg-[#30333f]
                  "
                >
                  Xeyr, razı deyiləm
                </button>

                <button
                  type="button"
                  onClick={
                    handleMonthlyAgree
                  }
                  className="
                    touch-manipulation
                    rounded-[10px]
                    border-0
                    bg-[#FFB800]
                    px-5
                    py-2.5
                    text-sm
                    font-extrabold
                    text-[#111]
                    transition
                    hover:brightness-110
                  "
                >
                  Razıyam, davam et
                </button>
              </div>
            </div>
          </div>
        )}

        {/* =====================================================
            ORDER MODAL
        ====================================================== */}

        {modalOpen && (
          <div
            className="
              fixed
              inset-0
              z-[9999999999999999]
              flex
              items-center
              justify-center
              overflow-hidden
              p-3
              sm:p-4
            "
            style={{
              height: viewportHeight
                ? `${viewportHeight}px`
                : "100dvh",

              paddingTop:
                "max(0.75rem, env(safe-area-inset-top, 0px))",

              paddingBottom:
                "max(0.75rem, env(safe-area-inset-bottom, 0px))",
            }}
          >
            {/* BACKDROP */}

            <div
              className="
                fixed
                inset-0
                bg-black/80
                backdrop-blur-[8px]
              "
              onClick={closeModal}
            />

            {/* MODAL CONTAINER */}

            <div
              className="
                relative
                z-10
                flex
                w-full
                max-w-[540px]
                flex-col
                overflow-hidden
                rounded-[20px]
                border
                border-purple-500/40
                bg-white
                shadow-[0_25px_80px_rgba(0,0,0,.75)]

                sm:rounded-[24px]

                dark:bg-[#0D081D]
                dark:text-gray-100
                dark:shadow-[0_25px_80px_rgba(0,0,0,.75),0_0_35px_rgba(139,92,246,.20)]
              "
              style={{
                height:
                  "min(85dvh, 700px)",

                maxHeight:
                  "calc(100dvh - env(safe-area-inset-top, 0px) - env(safe-area-inset-bottom, 0px) - 24px)",
              }}
              role="dialog"
              aria-modal="true"
              aria-labelledby="order-modal-title"
              onClick={(event) =>
                event.stopPropagation()
              }
            >
              {/* FIXED HEADER */}

              <div
                className="
                  flex
                  shrink-0
                  items-center
                  justify-between
                  border-b
                  border-gray-200
                  p-4
                  sm:px-6
                  sm:py-4.5

                  dark:border-[#231842]
                "
              >
                <h4
                  id="order-modal-title"
                  className="
                    m-0
                    text-base
                    font-black
                    text-gray-900

                    sm:text-lg

                    dark:text-white
                  "
                >
                  <span className="mr-2 text-amber-400">
                    ✦
                  </span>

                  Sifariş Məlumatları
                </h4>

                <button
                  type="button"
                  onClick={closeModal}
                  aria-label="Bağla"
                  disabled={submitting}
                  className="
                    flex
                    h-8
                    w-8
                    touch-manipulation
                    items-center
                    justify-center
                    rounded-full
                    bg-gray-100
                    text-sm
                    font-bold
                    text-gray-500
                    transition
                    hover:bg-gray-200
                    hover:text-gray-900

                    sm:h-9
                    sm:w-9
                    sm:text-base

                    disabled:cursor-not-allowed
                    disabled:opacity-50

                    dark:bg-white/5
                    dark:text-gray-400
                    dark:hover:bg-white/10
                    dark:hover:text-white
                  "
                >
                  ✕
                </button>
              </div>

              {/* FORM */}

              <form
                onSubmit={handleSubmit}
                className="
                  flex
                  min-h-0
                  flex-1
                  flex-col
                  text-gray-600

                  dark:text-gray-300
                "
              >
                {/* SCROLLABLE CONTENT BODY */}

                <div
                  className="
                    min-h-0
                    flex-1
                    overflow-y-auto
                    overscroll-contain
                    px-4
                    py-3
                    sm:px-6
                  "
                  style={{
                    WebkitOverflowScrolling:
                      "touch",

                    overscrollBehavior:
                      "contain",

                    paddingBottom:
                      "calc(0.75rem + env(safe-area-inset-bottom, 0px))",
                  }}
                >
                  {/* PRODUCT */}

                  <label
                    className="
                      mb-1
                      block
                      text-[11px]
                      font-extrabold
                      uppercase
                      tracking-[.06em]
                      text-gray-500

                      dark:text-gray-400
                    "
                  >
                    Məhsul(lar)
                  </label>

                  <input
                    type="text"
                    value={selectedNames.join(
                      " + "
                    )}
                    readOnly
                    className="
                      w-full
                      rounded-xl
                      border
                      border-gray-200
                      bg-gray-50
                      px-3.5
                      py-2.5
                      text-xs
                      font-semibold
                      text-gray-900
                      outline-none

                      sm:py-3
                      sm:text-sm

                      dark:border-[#231842]
                      dark:bg-[#040209]
                      dark:text-white
                    "
                  />

                  {/* COUNT */}

                  <div className="mt-3 grid grid-cols-2 gap-3">
                    <div>
                      <label
                        className="
                          mb-1
                          block
                          text-[11px]
                          font-extrabold
                          uppercase
                          tracking-[.06em]
                          text-gray-500

                          dark:text-gray-400
                        "
                      >
                        Toplam Məhsul Sayı
                      </label>

                      <input
                        type="text"
                        value={`${selectedProducts.length} məhsul`}
                        readOnly
                        className="
                          w-full
                          rounded-xl
                          border
                          border-gray-200
                          bg-gray-50
                          px-3.5
                          py-2.5
                          text-xs
                          font-semibold
                          text-gray-900
                          outline-none

                          sm:py-3
                          sm:text-sm

                          dark:border-[#231842]
                          dark:bg-[#040209]
                          dark:text-white
                        "
                      />
                    </div>

                    <div>
                      <label
                        className="
                          mb-1
                          block
                          text-[11px]
                          font-extrabold
                          uppercase
                          tracking-[.06em]
                          text-gray-500

                          dark:text-gray-400
                        "
                      >
                        Miqdar (X)
                      </label>

                      <input
                        type="number"
                        min="1"
                        value={modalCount}
                        onChange={(event) => {
                          const value =
                            parseInt(
                              event.target.value,
                              10
                            );

                          setModalCount(
                            Number.isFinite(
                              value
                            ) &&
                            value >= 1
                              ? value
                              : 1
                          );
                        }}
                        className="
                          w-full
                          rounded-xl
                          border
                          border-gray-200
                          bg-gray-50
                          px-3.5
                          py-2.5
                          text-xs
                          font-semibold
                          text-gray-900
                          outline-none
                          transition
                          focus:border-amber-500/75
                          focus:ring-2
                          focus:ring-amber-500/[0.08]

                          sm:py-3
                          sm:text-sm

                          dark:border-[#231842]
                          dark:bg-[#040209]
                          dark:text-white
                        "
                      />
                    </div>
                  </div>

                  {/* TOTAL */}

                  <div className="mt-3">
                    <label
                      className="
                        mb-1
                        block
                        text-[11px]
                        font-extrabold
                        uppercase
                        tracking-[.06em]
                        text-gray-500

                        dark:text-gray-400
                      "
                    >
                      Ümumi Məbləğ (AZN)
                    </label>

                    <input
                      type="text"
                      value={finalTotal.toFixed(
                        2
                      )}
                      readOnly
                      className="
                        w-full
                        rounded-xl
                        border
                        border-gray-200
                        bg-gray-50
                        px-3.5
                        py-2.5
                        text-lg
                        font-black
                        text-amber-500
                        outline-none

                        sm:py-3
                        sm:text-xl

                        dark:border-[#231842]
                        dark:bg-[#040209]
                        dark:text-amber-400
                      "
                    />
                  </div>

                  {/* PUBG ID */}

                  <div className="mt-3">
                    <label
                      className="
                        mb-1
                        block
                        text-[11px]
                        font-extrabold
                        uppercase
                        tracking-[.06em]
                        text-gray-500

                        dark:text-gray-400
                      "
                    >
                      Oyunçu ID
                    </label>

                    <input
                      type="text"
                      required
                      inputMode="numeric"
                      autoComplete="off"
                      placeholder="PUBG ID-nizi daxil edin"
                      value={userId}
                      onChange={(event) =>
                        setUserId(
                          event.target.value
                        )
                      }
                      className="
                        w-full
                        rounded-xl
                        border
                        border-gray-200
                        bg-gray-50
                        px-3.5
                        py-2.5
                        text-[16px]
                        font-semibold
                        text-gray-900
                        outline-none
                        transition
                        placeholder:text-gray-400
                        focus:border-amber-500/75
                        focus:ring-2
                        focus:ring-amber-500/[0.08]

                        sm:py-3
                        sm:text-sm

                        dark:border-[#231842]
                        dark:bg-[#040209]
                        dark:text-white
                        dark:placeholder:text-gray-600
                      "
                    />
                  </div>

                  {/* WORK TIME */}

                  <div
                    className="
                      mt-3
                      flex
                      items-center
                      gap-2
                      rounded-xl
                      border
                      border-amber-500/20
                      bg-amber-50
                      px-3.5
                      py-2.5
                      text-[10px]
                      font-bold
                      text-yellow-700

                      sm:text-[11px]

                      dark:bg-amber-500/[0.08]
                      dark:text-yellow-300
                    "
                  >
                    <span className="text-sm sm:text-base">
                      ⏱
                    </span>

                    İŞ SAATIMIZ: SƏHƏR 11:00 -
                    GECƏ 04:30
                  </div>

                  {/* CARD */}

                  <div
                    className="
                      mt-3
                      rounded-[14px]
                      border
                      border-gray-200
                      p-3
                      shadow-sm

                      sm:p-3.5

                      dark:border-[#231842]
                      dark:bg-gradient-to-br
                      dark:from-amber-500/[0.08]
                      dark:to-purple-500/[0.07]
                    "
                  >
                    <label
                      className="
                        mb-1
                        block
                        text-[10px]
                        font-extrabold
                        uppercase
                        tracking-[.06em]
                        text-gray-500

                        dark:text-gray-400
                      "
                    >
                      Kart Məlumatı
                    </label>

                    <h3
                      className="
                        m-0
                        break-words
                        text-xs
                        font-black
                        leading-[1.4]
                        tracking-[.4px]
                        text-amber-500

                        sm:text-sm

                        dark:text-amber-400
                      "
                    >
                      {kartInfo}
                    </h3>
                  </div>

                  {/* FILE */}

                  <div
                    className="
                      mt-3
                      rounded-[14px]
                      border
                      border-dashed
                      border-gray-300
                      bg-gray-50
                      p-3

                      dark:border-[#231842]
                      dark:bg-white/[0.015]
                    "
                  >
                    <div className="flex flex-col sm:flex-row sm:items-center sm:gap-3">
                      <label
                        htmlFor="upload-photo"
                        className="
                          inline-flex
                          cursor-pointer
                          touch-manipulation
                          items-center
                          justify-center
                          rounded-[11px]
                          border
                          border-gray-300
                          bg-white
                          px-3.5
                          py-2
                          text-xs
                          font-extrabold
                          text-gray-800
                          transition
                          hover:border-amber-500
                          hover:text-amber-500

                          dark:border-[#231842]
                          dark:bg-[#150E2A]
                          dark:text-white
                          dark:hover:text-amber-400
                        "
                      >
                        <span className="mr-1.5">
                          ↥
                        </span>

                        Qəbzi Seçin
                      </label>

                      <input
                        id="upload-photo"
                        type="file"
                        accept="image/*"
                        onChange={
                          handlePhotoChange
                        }
                        className="hidden"
                      />

                      <span
                        className="
                          mt-1.5
                          block
                          truncate
                          text-[11px]
                          text-gray-500

                          sm:mt-0
                          sm:flex-1

                          dark:text-gray-400
                        "
                      >
                        {uploadStatus}
                      </span>
                    </div>
                  </div>
                </div>

                {/* FIXED FOOTER BUTTONS */}

                <div
                  className="
                    flex
                    shrink-0
                    flex-row
                    items-center
                    justify-end
                    gap-2.5
                    border-t
                    border-gray-200
                    px-3.5
                    pt-3.5

                    sm:px-6

                    dark:border-[#231842]
                  "
                  style={{
                    paddingBottom:
                      "calc(0.875rem + env(safe-area-inset-bottom, 0px))",
                  }}
                >
                  <button
                    type="button"
                    onClick={closeModal}
                    disabled={submitting}
                    className="
                      flex-1
                      touch-manipulation
                      rounded-xl
                      border
                      border-gray-300
                      bg-transparent
                      px-4
                      py-2.5
                      text-xs
                      font-black
                      tracking-[.04em]
                      text-gray-600
                      transition
                      hover:bg-gray-100
                      hover:text-gray-900
                      disabled:cursor-not-allowed
                      disabled:opacity-50

                      sm:flex-none

                      dark:border-[#231842]
                      dark:text-gray-300
                      dark:hover:bg-white/5
                      dark:hover:text-white
                    "
                  >
                    Bağla
                  </button>

                  <button
                    type="submit"
                    disabled={submitting}
                    className="
                      flex-1
                      touch-manipulation
                      rounded-xl
                      border
                      border-amber-500
                      bg-gradient-to-r
                      from-amber-500
                      to-orange-500
                      px-4
                      py-2.5
                      text-xs
                      font-black
                      tracking-[.04em]
                      text-[#080510]
                      shadow-[0_0_25px_rgba(255,184,0,.22)]
                      transition
                      hover:-translate-y-0.5
                      hover:brightness-110
                      disabled:cursor-not-allowed
                      disabled:opacity-60

                      sm:flex-none
                    "
                  >
                    {submitting
                      ? "Göndərilir..."
                      : "SİFARİŞİ TƏSDİQLƏ"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
      </main>
    </>
  );
}